import { defineComponent as _defineComponent } from 'vue'
import { Popover } from 'ant-design-vue'
import type { RouteConfig } from 'vue-router'
import { useRouter, useRoute } from '@/hooks/useRouter'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavTopItems',
  props: {
    route: null
  },
  setup(__props: any) {

const { route } = __props as {
  route: RouteConfig
};



const router = useRouter()
const currentRoute = useRoute()

function getSubRouter() {
  if (Array.isArray(route.children)) {
    const result = [] as { name: string; path: string }[]
    route.children.forEach((item) => {
      if (item.meta?.hide) {
      } else {
        result.push({
          name: item.name || '',
          path: `${route.path}/${item.path}`,
        })
      }
    })
    return result
  }
  return []
}

function isActive(path: string) {
  if (currentRoute.value) {
    return currentRoute.value.path.indexOf(path) === 0
  }
  return false
}

function toPath(path: string, route?: RouteConfig) {
  if (currentRoute.value.path !== path && route?.redirect !== currentRoute.value.path) {
    router.push(path)
  }
}

function getPopupContainer(triggerNode: HTMLDivElement) {
  return triggerNode
}

return { __sfc: true,router, currentRoute, getSubRouter, isActive, toPath, getPopupContainer, Popover }
}

})